export const CAMPAIGN_REQUEST = "CAMPAIGN_LIST_REQUEST";
export const CAMPAIGN_LIST_SUCCESS = "CAMPAIGN_LIST_SUCCESS";
export const CAMPAIGN_FAIL = "CAMPAIGN_LIST_FAIL";

export const CAMPAIGN_EDIT_SUCCESS = "CAMPAIGN_EDIT_SUCCESS";
export const CAMPAIGN_ADD_SUCCESS = "CAMPAIGN_ADD_SUCCESS";
export const CAMPAIGN_DELETE_SUCCESS = "CAMPAIGN_DELETE_SUCCESS";

export const SAVE_CAMPAIGN_FILTER = "SAVE_CAMPAIGN_FILTER";

export const SELECTED_CONTACTS_FOR_CAMPAIGN = "SELECTED_CONTACTS_FOR_CAMPAIGN";

export const SELECTED_CAMPAIGN = "SELECTED_CAMPAIGN";

export const EMPTY_CAMPAIGN = "EMPTY_CAMPAIGN";

export const CAMPAIGN_GET_ONE_SUCCESS = "CAMPAIGN_GET_ONE_SUCCESS";
